import { GetSpecialistDetailResponse } from '@/modules/accredited-establishments/api'
import { getAppointmentLabel } from '@/modules/accredited-establishments/functions/getAppointmentLabel'

/*
 * O handoff (node 26:40868) mostra tres tags sob o nome: especialidade,
 * modalidade de atendimento e conselho.
 */
const getSpecialistTags = (specialist: GetSpecialistDetailResponse) => {
  const { specialty, council } = specialist

  return [specialty, getAppointmentLabel(specialist), council].filter(
    (tag): tag is string => Boolean(tag)
  )
}

export { getSpecialistTags }
